import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AzmoonMaharatMain_Interface, Empty_AzmoonMaharatMain_Interface } from 'src/app/Interface/AzmoonMaharatMain_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { AzmoonMaharatService } from 'src/app/Service/AzmoonMaharat/AzmoonMaharat.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-AzmoonMaharatMainForm',
  templateUrl: './AzmoonMaharatMainForm.component.html',
  styleUrls: ['./AzmoonMaharatMainForm.component.scss']
})
export class AzmoonMaharatMainFormComponent implements OnInit {



  @Input() inner_AzmoonMaharatMain: AzmoonMaharatMain_Interface = Empty_AzmoonMaharatMain_Interface()

  @Output() outter_AzmoonMaharatMain = new EventEmitter<number>();
  InProccessing: boolean = false
  modalRef_Delete: any;
  page: any

  constructor(
    private AzmoonMaharat_Service: AzmoonMaharatService,
    private modalService: BsModalService,
    private Alertify_Service: AlertifyService
  ) { }

  ngOnInit() {

    this.AzmoonMaharatForm = new FormGroup({
      id: new FormControl(),
      code: new FormControl(null, Validators.required),
      title: new FormControl(null, Validators.required),
    })


    this.get_Form_title().setValue(this.inner_AzmoonMaharatMain.title + '')
    this.get_Form_code().setValue(this.inner_AzmoonMaharatMain.code + '')


  }

  //#region  Form Add

  AzmoonMaharatForm: FormGroup;

  get_Form_code() {
    return this.AzmoonMaharatForm.get('code') as FormControl;
  }

  get_Form_title() {
    return this.AzmoonMaharatForm.get('title') as FormControl;
  }

  //#endregion

  OnSubmit() {

    var temp: AzmoonMaharatMain_Interface = Empty_AzmoonMaharatMain_Interface()
    temp.id = this.inner_AzmoonMaharatMain.id
    temp.code = this.get_Form_code().value
    temp.title = this.get_Form_title().value



    this.InProccessing = true
    this.AzmoonMaharat_Service.AddAzmoonMaharat(temp).subscribe(
      data => {
        this.InProccessing = false
        if (data.id == -2)
          this.Alertify_Service.ErrorMessage("عنوان در سامانه موجود است")
        else {
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          if (this.inner_AzmoonMaharatMain.id == 0)
            this.AzmoonMaharatForm.reset()
        }
      }
    )


  }


  onBack() {
    this.outter_AzmoonMaharatMain.emit(-1);
  }


}
